import { PAGE_URL, PERMISSION_KEY } from "../services/constant";

const apiKeyPermissionGroupMenuRegistry = {
    core_apiKeyPermissionGroup: {
        label: "API Key Permission Group",
        link: PAGE_URL.API_KEY_PERMISSION_GROUP_PAGE,
        key: PAGE_URL.API_KEY_PERMISSION_GROUP_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default apiKeyPermissionGroupMenuRegistry;
